import triyoAPI from "./triyo";
import { config } from "../../util/axios-config";

export const GetDynamicFormData = (data) => {
  return triyoAPI.get(
    `/DynamicForms/GetDynamicFormData?DynamicFormId=${data.Id}&taskId=${data.taskId}`,
    config()
  );
};

export const SaveDynamicFormData = (data) => {
  return triyoAPI.post(
    `/DynamicForms/SaveDynamicFormData`,
    data,
    config("POST")
  );
};

export const GetDynamicFormsForAdminPage = (data) => {
  return triyoAPI.get(
    `/DynamicForms/GetDynamicFormsForAdminPage?TaskTypeId=${data}`,
    config()
  );
};

export const ImportData = (id) => {
  return triyoAPI.get(`/data/external/libro-owner-details/${id}`, config());
};

export const GetStatusForImportData = (id) => {
  return triyoAPI.get(`/data/external/libro-transactions-status/${id}`, config());
};

export const GetDynamicFieldsForAdminPage = (data) => {
  return triyoAPI.get(
    `/DynamicForms/GetDynamicFieldsForAdminPage?TaskTypeId=${data}`,
    config()
  );
};

export const GetCustomFieldData = (FieldID, CustomFormula, Form) => {
  const data = {
    FieldID,
    CustomFormula,
    Form
  };
  return triyoAPI.post(`/DynamicForms/GetCustomFieldData`, data, config("POST"));
};

export const GetExternalForm = (guid) => {
  return triyoAPI.get("/DynamicForms/GetExternalForm?FormId="+ guid, );
};

export const CreateTaskFromExternalForm = (data) => {
  return triyoAPI.post("/DynamicForms/CreateTaskFromExternalForm", data );
};

export const GetDynamicFormFieldFile = (guid) => {
  return triyoAPI.get(`/DynamicForms/GetDynamicFormFieldFile?Id=${guid}`, config());
};

export const GetDynamicFormAutomations = (taskTypeId, formId) => {
  return triyoAPI.get(`/dynamic-form-automations/user/${taskTypeId}/${encodeURIComponent(formId)}`, config());
};

export const SaveInitialReviewPeriodDates = (data) => {
  return triyoAPI.post(`/DynamicForms/SaveInitialReviewPeriodDates`, data, config("POST"));
}